import type { GlobalSearchItem } from "../../utils/websearchParse";
import { NEUTRAL_AVATAR } from "../../utils/neutralAvatar";
import "./searchResultContent.scss";

const BADGE_COLORS = ["#2B4C8C", "#8C2B2B", "#3D6B4F", "#5B5F6B", "#6B3D8C", "#8C6B2B"];
const badgeColor = (s: string) => BADGE_COLORS[[...s].reduce((a, c) => a + c.charCodeAt(0), 0) % BADGE_COLORS.length];
const initialsOf = (s: string) => s.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

/**
 * Leading visual for a search row: the item's photo/logo when present. Players fall back to a
 * gender-neutral silhouette; leagues, tournaments and teams fall back to a coloured initials badge.
 */
export const SearchAvatar = ({ item }: { item: GlobalSearchItem }) => {
  const isPlayer = item.type === "player";
  if (!item.imageUrl && !isPlayer) {
    return (
      <span className={`sr-avatar sr-avatar--badge sr-avatar--${item.type}`} style={{ background: badgeColor(item.title) }} aria-hidden="true">
        {initialsOf(item.title)}
      </span>
    );
  }
  return (
    <img
      className={`sr-avatar sr-avatar--${item.type}`}
      src={item.imageUrl || NEUTRAL_AVATAR}
      alt=""
      loading="lazy"
      onError={(e) => {
        if (e.currentTarget.src !== NEUTRAL_AVATAR) e.currentTarget.src = NEUTRAL_AVATAR;
      }}
    />
  );
};

/** Contents of a header-dropdown result row: avatar, title + type chip, and a context line beneath. */
const SearchResultContent = ({ item }: { item: GlobalSearchItem }) => {
  const subtitle = item.type === "player" ? item.playerCode ?? item.subtitle : item.subtitle;
  return (
    <span className="sr-player-row">
      <SearchAvatar item={item} />
      <span className="sr-player-body">
        <span className="header-search-result-top">
          <span className="header-search-result-title">{item.title}</span>
          <span className={`header-search-result-type type-${item.type}`}>{item.type}</span>
        </span>
        {subtitle && <span className="header-search-result-subtitle">{subtitle}</span>}
      </span>
    </span>
  );
};

export default SearchResultContent;
